import { RISR_FORM_TYPE_EXPANDER } from "@fry-it/risr-core";
import { BlueprintFieldExpander } from "./blueprints/blueprint-field-expander";
import { BlueprintCategoryFieldExpander } from "./blueprints/blueprint-category-field-expander";
import { UserFieldExpander } from "./users/user-field-expander";
import { EventTypeFieldExpander } from "./event-types/event-type-field-expander";
import { RelationCategoryFieldExpander } from "./relations/relation-category-field-expander";
import { EventStateFieldExpander } from "./events/event-state-field-expander";

const fieldExpanders = [
    { provide: RISR_FORM_TYPE_EXPANDER, useClass: BlueprintFieldExpander, multi: true },
    { provide: RISR_FORM_TYPE_EXPANDER, useClass: BlueprintCategoryFieldExpander, multi: true },
    { provide: RISR_FORM_TYPE_EXPANDER, useClass: UserFieldExpander, multi: true },
    { provide: RISR_FORM_TYPE_EXPANDER, useClass: EventTypeFieldExpander, multi: true },
    { provide: RISR_FORM_TYPE_EXPANDER, useClass: RelationCategoryFieldExpander, multi: true },
    { provide: RISR_FORM_TYPE_EXPANDER, useClass: EventStateFieldExpander, multi: true }
]

export function provideFieldExpanders() {
    return fieldExpanders;
}
